import { render } from "./BarTu.vue?vue&type=template&id=676c8abe&scoped=true"
import script from "./BarTu.vue?vue&type=script&lang=js"
export * from "./BarTu.vue?vue&type=script&lang=js"

import "./BarTu.vue?vue&type=style&index=0&id=676c8abe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-676c8abe"

export default script